const required = (value)=>{
    if(value != null && value != ''){
        return true
    } else {
        return false
    }
}

export default {
    'contact_name': {
        value: '',
        validator: required,
        errorMessage: 'Field is required',
        is_touched: false
    },
    'phone': {
        value: '',
        validator: (value)=> {
            return value != null && value.length === 12 && required(value);
        },
        errorMessage: 'Must enter a valid phone number',
        is_touched: false
    },
    'email': {
        value: '',
        validator: required,
        errorMessage: 'Field is required',
        is_touched: false
    }
}


